import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { dashboardAsset } from "../../utils/dashboardAssets";
import { useAuth } from "../../context/AuthContext";

function displayWelcomeName(user) {
  if (!user || typeof user !== "object") return "Operator";
  const u = String(user.username || "").trim();
  if (u) return u;
  const em = String(user.email || "").trim();
  if (em) return em.split("@")[0] || em;
  return "Operator";
}

function initialsFor(user) {
  const name = displayWelcomeName(user);
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase().slice(0, 2);
  return name.slice(0, 2).toUpperCase() || "TD";
}

const GatewayHero = () => {
  const { user } = useAuth();
  const welcomeName = useMemo(() => displayWelcomeName(user), [user]);
  const initials = useMemo(() => initialsFor(user), [user]);

  return (
    <section className="dg-hero dg-gold-ring dg-premium-ring dg-hero--cinema">
      <div className="dg-hero__visual">
        <img
          className="dg-hero__bg"
          src={dashboardAsset("01_hero_oshar_city_spires.png")}
          alt=""
          loading="eager"
        />
        <div className="dg-hero__vignette" />
        <div className="dg-hero__vignette dg-hero__vignette--radial" />
        <div className="dg-hero__hero-bloom" aria-hidden />
        <div className="dg-hero__glow-corner" />
        <div className="dg-hero__compass-arc" aria-hidden />

        <div className="dg-hero__content">
          <div className="dg-hero__left dg-hero__left--readable">
            <div className="dg-hero__avatar-ring dg-hero__avatar-ring--rank">
              <div className="dg-hero__avatar">
                <span>{initials}</span>
              </div>
              <span className="dg-hero__avatar-crown" aria-hidden>
                <i className="fas fa-star" />
              </span>
            </div>
            <p className="dg-hero__welcome dg-label-up">Welcome back, {welcomeName}</p>
            <p className="dg-hero__level">Member</p>
            <p className="dg-hero__rank-hint dg-muted" style={{ margin: "6px 0 10px", fontSize: "0.72rem", lineHeight: 1.45 }}>
              Rank and XP progression are not published on this dashboard yet.
            </p>
            <blockquote className="dg-hero__quote">
              “The future of Oshar is in your hands.”
            </blockquote>
          </div>

          <div className="dg-hero__right">
            <h1 className="dg-hero__title serif dg-hero__title--bloom">Oshar Awaits</h1>
            <p className="dg-hero__subtitle">Build. Trade. Explore. Leave your legacy.</p>
            <Link to="/world/oshar" className="dg-btn dg-btn--hero-enter dg-btn--portal dg-btn--sweep">
              Enter Oshar <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GatewayHero;
